import Web3 from "web3";
export const web3 = new Web3(Web3.givenProvider || 'https://bsc-dataseed1.binance.org');

export const connectWallet = async () => {
    const account = await web3.eth.requestAccounts();
    const userAccount = account[0];
    return userAccount;
}

